
import { ContentBlockImageData, rem } from 'fourwaves-shared';
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class ContentBlockImage extends Vue {
  @Prop({ type: Object, required: true }) readonly image!: ContentBlockImageData;
  @Prop({ type: Number, required: true }) readonly aspectRatio!: number;
  @Prop({ type: [Number, String], default: 12 }) readonly borderRadius!: number | string;
  @Prop({ type: Number, required: false }) readonly width!: number;

  get rootStyles(): Record<string, number | string | null> {
    return {
      '--border-radius': typeof this.borderRadius === 'number' ? rem(this.borderRadius) : this.borderRadius,
      '--aspect-ratio': this.aspectRatio,
    };
  }

  get imageUrl(): string {
    const imageSource = this.image.url[this.$i18n.locale] || this.image.originalUrl[this.$i18n.locale];
    if (!imageSource) return '';

    const url = new URL(imageSource);
    url.searchParams.set('fit', 'max');
    url.searchParams.set('auto', 'format');

    if (this.width) url.searchParams.set('w', this.width.toString());

    return url.toString();
  }
}
